import React from 'react';

import Copter from './Copter';
import Plane from './Plane';
import Rover from './Rover';

const FailSafe = ({ robot }) => {
  switch (robot.model.vehicle) {
    case 'Rover':
      return <Rover robot={robot} />;

    case 'Copter':
      return <Copter robot={robot} />;

    case 'Plane':
      return <Plane robot={robot} />;

    default:
      return null;
  }
};

export default FailSafe;
